function duplicateTaskDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/duplicate-task/duplicate-task-dialog.html?$$REVISION$$'
  }
}
export { duplicateTaskDialog }
